import { businessSuiteWeb, flipflopWeb, profileDashboardWeb, timesheetWeb } from "assets";
import React, { useEffect, useRef, useState } from "react";
import { Carousel, CarouselContent, CarouselItem } from "components/ui/carousel";

const LeftBarPageRegisterLogin = ({ children }: { children: React.ReactNode }) => {
  const backgroundImages = [flipflopWeb, businessSuiteWeb, profileDashboardWeb, timesheetWeb];

  const [api, setApi] = useState<any>(null);
  const currentIndex = useRef(0);

  useEffect(() => {
    if (!api) return;

    const interval = setInterval(() => {
      currentIndex.current = (currentIndex.current + 1) % backgroundImages.length;
      api.scrollTo(currentIndex.current);
    }, 5000); // Auto-slide every 5 seconds
    return () => clearInterval(interval); // Clean up on unmount
  }, [api]);
  return (
    <div className=" h-screen lg:h-full w-full lg:w-[60%] relative">
      <Carousel className="h-full w-full" setApi={setApi}>
        <CarouselContent>
          {backgroundImages.map((url, index) => (
            <CarouselItem key={index} className="h-full w-full">
              <img src={url} alt="" className=" h-screen w-full lg:object-fill md:object-fill object-cover" />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
      <div className="absolute inset-0 flex items-center justify-center px-4 py-10 lg:hidden bg-black/50">{children}</div>
    </div>
  );
};

export default LeftBarPageRegisterLogin;
